<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="320">
      <v-card>
        <v-card-title class="text-h5">
          Solicitar ajuda
        </v-card-title>
        <v-card-text>
          Telefone móvel
        </v-card-text>

        <v-card-text>
          (244) 949 867 642
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-grey darken-1" text @click="dialogClose">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import eventBus from "../../../../main";
export default {
  name: "ModalOpenCallCellphone",
  data: () => ({
    valid: false,
    dialog: false,
  }),
  methods: {

    dialogClose() {
      this.dialog = false;
    }
  },
  created() {
    const self = this;
    eventBus.$on("openCallCellphone", function(payload) {
      self.dialog = payload;
    });
  }
};
</script>

<style scoped></style>
